module.exports = __webpack_public_path__ + "img/coopeuch.e1802ff.png";